export default __webpack_public_path__ + "static/lucinski_3-2-e79089ff469831d2c8b46d2e40d92519.jpg";